export default {
  "agentManagement": {
    "runtime": {
      "action": "Connect feature",
      "title": "Feature setup · {{name}}",
      "feature": "Feature variant",
      "selectFeature": "Select a feature variant",
      "feature_change_color": "One-click color change",
      "feature_poster_standard": "AI poster · Standard",
      "feature_image_fission": "Image fission",
      "feature_batch_matting": "Batch cutout",
      "feature_ai_model": "AI model replacement",
      "feature_model_background_reference": "Model background · With reference",
      "feature_model_background_no_reference": "Model background · Without reference",
      "model_pairHelp": "Model background uses two agents. Switch both options together; visibility and publication remain separate.",
      "model_pairBind": "Switch both model background options",
      "model_pairBindTitle": "Switch both model background options?",
      "model_pairUnbind": "Restore both original model background options",
      "model_pairUnbindTitle": "Restore both original model background options?",
      "feature_product_background_reference": "Product background · With reference",
      "feature_product_background_no_reference": "Product background · Without reference",
      "pairHelp": "Product background uses two agents. Switch both entries together; visibility and publication status remain separate.",
      "pairPartner": "Select {{feature}} agent",
      "pairSearch": "Search by agent name or identifier",
      "pairPartnerInvalid": "The matching active content could not be confirmed. Reload, or review and activate the required variant before selecting it.",
      "pairSearchFailed": "Agents could not be read. Search again or reload the actual state.",
      "pairCurrentMismatch": "Select the variant matching this agent’s active snapshot first.",
      "pairBind": "Switch both product background entries",
      "pairBindTitle": "Switch both product background entries?",
      "pairBindBody": "Current: {{before}}. Selected: {{after}}. This agent: {{current}}. Other agent: {{name}} · {{partner}}. Both entries change in one operation for new requests; accepted tasks keep their original content and price.",
      "pairUnbind": "Restore both original product background entries",
      "pairUnbindTitle": "Restore both original product background entries?",
      "pairUnbindBody": "Current: {{before}}. Both bindings will be removed together for new requests. Accepted tasks keep their original snapshots and will not be charged again.",
      "feature_poster_quality": "AI poster · High quality",
      "bindingReadFailed": "The selected feature entry could not be read. Confirm the service is ready, then reload.",
      "scope": "Saving a draft does not change the active snapshot. New requests use the active content; accepted tasks keep their original snapshot and pricing.",
      "readFailed": "Runtime settings could not be read. Release management may not be enabled in this environment. Check service readiness and reload.",
      "releaseFailed": "The selected snapshot could not be read. Reload before reviewing it.",
      "writeUnconfirmed": "The operation outcome is unconfirmed. Further changes are paused. Reload the actual state before continuing.",
      "refresh": "Reload state",
      "saved": "Operation succeeded. Checking the latest state.",
      "policyInvalid": "Invalid pricing settings. Select a pricing mode and enter valid credits per execution for fixed pricing.",
      "confirm": "Confirm change",
      "cancel": "Cancel",
      "close": "Close",
      "fixedSummary": "{{points}} credits per execution",
      "dynamic": "Dynamic workflow node pricing",
      "maximum": "Up to {{count}} executions",
      "image": "Images (one image per execution)",
      "set": "Sets (multiple images per execution)",
      "active": "Active snapshot",
      "notPublished": "No active snapshot",
      "binding": "Feature entry",
      "boundHere": "Bound to this agent",
      "boundOther": "Bound to agent {{id}}",
      "unbound": "Unbound; using the original execution path",
      "prepareTab": "Prepare snapshot",
      "configurationSource": "Quantity and outputs come from the existing agent configuration. No pricing fields are added to the workflow or form files, and no extra policy file is required.",
      "prepareHelp": "Save the ComfyUI workflow and API exports and the standard bilingual agent configurations first. Set only this agent’s pricing here. Fixed total price is unit price × execution count.",
      "billing": "Pricing mode",
      "fixed": "Fixed price per execution",
      "points": "Credits per execution",
      "required": "Select or enter a value.",
      "prepare": "Prepare snapshot for review",
      "releaseTab": "Review, activate / revert",
      "selectRelease": "Select a release snapshot",
      "current": "Active",
      "allOutputs": "Every declared output is required. Missing or incompletely stored outputs fail that execution and refund its actual charge.",
      "policy": "Runtime policy",
      "configCn": "Chinese form",
      "configEn": "English form",
      "workFlowApi": "Execution graph",
      "workFlow": "Editor graph",
      "reviewed": "I have reviewed the selected workflow, both language configurations and pricing.",
      "activateTitle": "Activate this snapshot?",
      "activateBody": "Agent: {{name}}. Switch from {{before}} to {{after}}; {{summary}}. New requests will use this content and pricing. Selecting a previous snapshot reverts to it.",
      "activate": "Activate selected content",
      "bindingTab": "Feature binding",
      "bindingHelp": "Only an active agent matching the selected feature variant can be bound. AG still controls visibility separately. Binding does not change visibility or publication status.",
      "bind": "Bind this feature entry to the agent",
      "bindTitle": "Switch the feature entry?",
      "bindBody": "Feature: {{feature}}. Previous binding: {{before}}. New binding: {{name}} ({{after}}). {{summary}}. New requests will use the active snapshot.",
      "unbind": "Remove the selected feature binding",
      "unbindTitle": "Restore the feature's original execution path?",
      "unbindBody": "Removing the {{feature}} binding restores its original execution path for new requests. Accepted tasks keep their original snapshots and will not be charged again."
},
    "workflowEditAction": "Edit workflow",
    "workflowEditReading": "Loading the latest workflow. Saving is unavailable until it is ready.",
    "workflowEditReadFailed": "The latest workflow could not be confirmed. Reload its content before editing or saving.",
    "workflowEditReadRetry": "Reload content",
    "workflowEditConflict": "The workflow was changed by another operation. Keep your edits, then close and reopen it to compare.",
    "navigation": "Navigation",
    "openNavigation": "Open navigation menu",
    "feishuConfirmOwnershipBody": "Sync destination: {{environment}}. New items will use the listed creators and teams and will be saved as unverified. Confirm the accounts and receiving scope.",
    "feishuSyncTask": "Feishu content sync task",
    "feishuResetView": "Back to source selection",
    "feishuConfirmTitle": "Confirm content sync",
    "feishuReplaceOnlineBody": "This will replace {{count}} live items in {{environment}} while retaining their current publication status. Review the changes and target ownership.",
    "feishuChanges": "Content changes",
    "feishuNewContent": "Create full content",
    "feishuOtherChanges": "Other content",
    "feishuNoChanges": "No content changes detected",
    "previewChangesUnavailable": "Content comparison unavailable. Review the preview result.",
    "feishuDiff_titleCn": "Chinese name",
    "feishuDiff_titleEn": "English name",
    "feishuDiff_coverImage": "Covers",
    "feishuDiff_detail": "Chinese details",
    "feishuDiff_detailEn": "English details",
    "feishuDiff_node": "Node dependencies",
    "feishuDiff_workFlow": "Workflow content",
    "feishuDiff_workFlowApi": "Execution settings",
    "feishuDiff_courseCn": "Chinese tutorial",
    "feishuDiff_courseEn": "English tutorial",
    "feishuDiff_showType": "Display scope",
    "feishuDiff_canDownload": "Download permission",
    "feishuDiff_joinDiscount": "Discount settings",
    "feishuDiff_recommend": "Recommendation",
    "feishuDiff_points": "Rating",
    "feishuDiff_configCn": "Chinese parameter settings",
    "feishuDiff_configEn": "English parameter settings",
    "feishuDiff_classification": "Category",
    "feishuDiff_label": "Labels",
    "feishuTitle": "Sync from Feishu",
    "feishuRead": "Read source",
    "feishuReadAgain": "Read source again",
    "feishuSelect": "Select content and ownership",
    "feishuPreview": "Review and confirm",
    "feishuNote": "Reading and previewing do not modify Feishu or current content. Existing items keep their status and ownership; new items start as unverified. Changes are written only after confirmation.",
    "feishuLoading": "Loading sources and records",
    "feishuLoadFailed": "Sources and records could not be loaded. Try again.",
    "feishuUnavailable": "Feishu sources are not enabled in this environment. Ask an administrator to check sheet and asset read access.",
    "feishuSource": "Feishu source",
    "feishuRecords": "Read and preparation records",
    "previewDeadlines": "Preview deadlines",
    "previewConfirmDeadline": "Confirm by: {{time}}",
    "previewRetentionDeadline": "Prepared content retained until {{time}}. Rechecking does not extend this deadline.",
    "feishuRecheck": "Recheck prepared content",
    "feishuRecheckNote": "Reuse the prepared attachments and assets to check the current target. This does not read the latest Feishu content or extend retention. Read the source again for updates.",
    "feishuRecheckUnavailable": "This content cannot be reused or its retention has ended. Read the source again and prepare the content.",
    "feishuReviewExpired": "View previous preview",
    "feishuRetrySubmit": "Retry same submission",
    "feishuPrepare": "Prepare preview",
    "feishuTaskReadFailed": "Task status could not be verified. Retry reading its status; avoid confirming the same sync again.",
    "feishuSubmitFailed": "Task submission was not confirmed. Retry the same action; the same request will not run twice.",
    "feishuCloseHint": "You may close this window. The task will continue and its result will be available in the records.",
    "feishuStage_QUEUED": "Queued",
    "feishuStage_RUNNING": "Reading or preparing",
    "feishuStage_READY": "Ready",
    "feishuStage_FAILED": "Failed",
    "feishuStage_INTERRUPTED": "Interrupted",
    "feishuFailed": "Reading or preparation did not complete. Check the source before trying again.",
    "feishuSearch": "Name or identifier",
    "feishuSearchPlaceholder": "Enter a Chinese name, English name or identifier",
    "feishuMatches": "Showing {{count}} / {{total}} · Selected {{selected}} (including hidden items)",
    "feishuSearchEmpty": "No matching content. Change or clear your search.",
    "feishuSnapshot": "Source: {{name}} · Read completed: {{time}}",
    "feishuExpired": "This source snapshot has expired. Read the source again.",
    "feishuCatalogExpiredWithPreview": "The source catalog has expired. Read it again before preparing new content. An existing preview follows its own confirmation deadline.",
    "feishuSourceIssues": "These source rows need attention and cannot be selected. Other valid rows can be selected for preview.",
    "feishuShowSourceIssues": "Show {{count}} issues",
    "feishuHideSourceIssues": "Hide {{count}} issues",
    "feishuKind": "Content type",
    "feishuAgent": "Agent",
    "feishuWorkflow": "Workflow",
    "feishuSourceState": "Sync action",
    "feishuDeleted": "Marked deleted in source",
    "sourceOwnershipChecked": "Asset ownership confirmed for this preparation",
    "sourceOwnershipTitle": "Verify source asset ownership",
    "sourceGroupId": "Source asset team ID",
    "sourceOwnershipHelp": "Enter the team that owns the assets referenced in the attachments. Use 0 only for verified official assets. This does not change the target creator or team. Do not copy the visible teams from Feishu.",
    "sourceOwnershipConfirm": "I have checked this record’s asset team and permitted use",
    "sourceOwnershipScope": "Applies only to selected records in this catalog and preparation. It grants no additional asset access and does not automatically publish private team assets.",
    "sourceOwnershipUnavailable": "Some content cannot be selected until its asset ownership is verified. Contact the source owner to confirm the permitted use. Verified content can still be prepared.",
    "sourceOwnershipRequired": "Enter and confirm the source asset team for each selected record, then verify target ownership before preparing the preview.",
    "feishuSelectContent": "Select content: {{name}}",
    "feishuTeamUnverified": "Source asset team needs verification",
    "feishuRow": "Source row",
    "feishuOwnershipSource": "Choose and verify the creator and teams in this environment. Feishu account and team values do not automatically grant target ownership.",
    "feishuPrepareSelection": "Prepare and preview selection ({{count}})",
    "feishuPrepared": "Preview passed. Review creations, updates and ownership before confirming.",
    "feishuReview": "Review sync preview",
    "feishuConfirmNote": "This preview is bound to the prepared attachments, assets and current target content. Existing items retain their status and ownership. Preview again if the target changes or the preview expires.",
    "feishuConfirm": "Confirm sync",
    "title": "Agent management",
    "create": "Create agent",
    "edit": "Edit agent",
    "details": "View details",
    "delete": "Delete agent",
    "export": "Export package",
    "import": "Import package",
    "history": "Transfer history",
    "search": "Name or identifier",
    "name": "Name",
    "sign": "Stable identifier",
    "status": "Publication status",
    "OFFLINE": "Offline",
    "TEST": "Unverified",
    "ONLINE": "Online",
    "unknown": "Unknown status",
    "save": "Save changes",
    "saveNew": "Save for testing",
    "cancel": "Cancel",
    "retry": "Retry",
    "basic": "Basic information",
    "config": "Agent parameters",
    "execution": "Execution configuration",
    "visibility": "Visibility",
    "associationMode": "Creation mode",
    "newWorkflow": "Create a complete agent",
    "existingWorkflow": "Use an existing workflow",
    "workFlowId": "Select an existing workflow",
    "titleCn": "Chinese name",
    "titleEn": "English name",
    "detailCn": "Chinese description",
    "detailEn": "English description",
    "coverImageCn": "Chinese cover",
    "coverImageEn": "English cover",
    "draftCoverHelp": "Covers can be added while pending validation. Both languages are required before publishing.",
    "error_publicationCoverRequired": "Add the {{field}} before publishing.",
    "classification": "Category",
    "labels": "Labels",
    "configCn": "Chinese parameter configuration JSON",
    "configEn": "English parameter configuration JSON",
    "workFlow": "Editor workflow JSON",
    "workFlowApi": "Execution API JSON",
    "node": "Node dependencies",
    "courseCn": "Chinese tutorial URL",
    "courseEn": "English tutorial URL",
    "userId": "Creator user ID",
    "groupId": "Owning team ID",
    "owningGroupHelp": "Use an active team that includes the creator. 0 has no owning-team restriction; the visible-team list still controls access after publication.",
    "confirmOwnershipSave": "Confirm ownership and access, then save",
    "confirmAndSave": "Confirm and save",
    "ownershipSaveNote": "Check the account, teams and access scope in this environment. During testing, only the creator can verify in an authorized team context.",
    "owningTeamAudience": "After publication, the owning team and listed visible teams can access this agent.",
    "restrictedAudience": "After publication, only listed visible teams can access this agent.",
    "unrestrictedAudience": "After publication, access will have no team restriction.",
    "error_teamCreator": "Select an active maintainer from the owning team instead of official creator 0.",
    "points": "Rating",
    "canDownload": "Allow downloads",
    "verify": "Verified by a maintainer",
    "recommend": "Recommend",
    "joinDiscount": "Include in discounts",
    "joinMarket": "Show in the marketplace",
    "showInWorkFlow": "Also show in the workflow entry",
    "sharedGroups": "Visible teams",
    "groupsHelp": "Enter additional visible team IDs as a JSON array, such as [\"123\"]. An empty list adds no shared teams; with owning team 0, published access has no team restriction.",
    "creatorHelp": "Use a valid user ID for real generation testing. Ordinary users cannot run a test agent owned by creator 0. Restore official ownership later if required by the release plan.",
    "newNote": "New agents are saved for testing. Publish after checking parameters, images and real generation.",
    "associationNote": "Association keeps the workflow's publication state, ownership and access scope. If it is online, the new agent configuration takes effect immediately. Complete testing and keep the original configuration first.",
    "confirmAssociationSave": "Confirm association and save",
    "onlineNote": "This agent is online. Saving updates this environment immediately. Verify in a test environment and keep the original package first.",
    "configNote": "Keep the inputs and outputs arrays. Formatting preserves large integer seeds and asset paths.",
    "executionNote": "Keep both editor and execution API configurations. Node and input mappings must match.",
    "required": "Enter {{field}}",
    "loadFailed": "Unable to load the agent. Retry.",
    "optionsFailed": "Categories, labels or workflows did not load completely. Retry before saving.",
    "saved": "Agent saved",
    "noChanges": "No changes to save",
    "saveFailed": "Save failed. Your changes are retained. Retry.",
    "saveUnconfirmed": "Save result not confirmed",
    "saveUnconfirmedBody": "No definite save result was received. Content may already be saved. Your draft is retained and editing is paused. Check the result before submitting again.",
    "saveStillUnconfirmed": "Current content does not yet confirm this submission, or reading is unavailable. Keep checking without submitting, or close to inspect the list. A missing item does not mean the original request has stopped.",
    "checkSave": "Check save result",
    "saveTargetWorkflowId": "Linked workflow ID",
    "saveChecked": "Current content matches the submitted fields",
    "closeUnconfirmedTitle": "Close and check the list?",
    "closeUnconfirmedBody": "The original save result is still unconfirmed. Closing discards this window’s draft. Check current content in the list before reopening the editor.",
    "closeAndCheckList": "Close and view list",
    "keepChecking": "Keep draft and check",
    "discardTitle": "Discard unsaved changes?",
    "discard": "Discard changes",
    "keepEditing": "Continue editing",
    "confirmOnlineSave": "Update an online agent?",
    "confirmOnlineBody": "This environment will use the changes immediately. Confirm testing is complete and the original package is retained.",
    "confirm": "Confirm",
    "yes": "Yes",
    "no": "No",
    "cover": "Cover",
    "updated": "Updated",
    "usage": "Usage",
    "operations": "Actions",
    "publish": "Publish",
    "testStatus": "Set to test",
    "offline": "Take offline",
    "statusConfirm": "Set “{{name}}” to {{status}}?",
    "statusImpact": "This changes visibility and availability in this environment.",
    "statusSaved": "Publication status updated",
    "statusFailed": "Status update failed. Refresh and retry.",
    "deleteConfirm": "Delete “{{name}}”?",
    "keepWorkflow": "Keep the workflow and remove only the agent entry",
    "deleteWorkflow": "Remove both the agent and its workflow",
    "deleted": "Agent removed",
    "deleteFailed": "Removal failed. Retry.",
    "selectExport": "Select agents to export",
    "importTitle": "Import an agent package",
    "file": "Package file",
    "chooseFile": "Choose a .tar package",
    "importNote": "Import a .tar package from a verified environment. Matching stable IDs update existing objects and keep their publication status. New objects are saved for testing.",
    "startImport": "Start import",
    "importBlocked": "Needs correction",
    "targetUserId": "Target creator user ID",
    "targetGroupId": "Target owning team ID",
    "targetSharedGroups": "Target visible team IDs",
    "officialCreator": "Official creator",
    "officialScope": "Official ownership",
    "noAdditionalTeams": "No additional shared teams",
    "ownershipSource": "Source creator {{user}}; owning team {{group}}; {{count}} restricted visible teams.",
    "ownershipHelp": "Check user and team IDs in customer details in this environment. Use 0 for official ownership and a JSON array for visible teams. Source IDs are references and are never applied automatically.",
    "ownershipInvalid": "Invalid target ownership. Check the creator and team IDs.",
    "ownership_invalidId": "{{field}} must be a complete integer ID.",
    "ownership_invalidIdList": "Visible teams must be a JSON array of valid IDs, without duplicates or 0, with at most 100 teams.",
    "ownership_privateGroup": "Select a target owning team for this team content; import cannot make it publicly owned.",
    "ownership_teamCreator": "Select a maintainer in the owning team; official creator 0 is not allowed for a team agent.",
    "ownership_privateAudience": "The source restricts visible teams. Select target visible teams; do not clear the restriction.",
    "ownership_uncheckedOwnership": "Check every target creator and team before previewing the package again.",
    "ownershipReadFailed": "Could not verify target ownership. Check users, teams and membership, then retry.",
    "checkOwnership": "Check target ownership",
    "ownershipChecked": "Target ownership checked",
    "ownershipRecheck": "Ownership changed. Preview the package again; the previous preview cannot be confirmed.",
    "confirmOwnershipTitle": "Confirm ownership in this environment?",
    "confirmOwnershipBody": "Destination: {{environment}}. New agents will use the following creators and teams and remain pending validation. Confirm the target accounts and receiving teams.",
    "taskExport": "Package export task",
    "taskImport": "Package import task",
    "taskPending": "Processing, {{processed}} / {{total}}",
    "taskQueued": "Queued for processing",
    "close": "Close",
    "exportInterruptedShort": "Interrupted; export again",
    "exportInterrupted": "Export was interrupted. Export the current content again and check the new package.",
    "exportLimitShort": "Export limit reached",
    "exportLimit": "The export reached its content or time limit. Select fewer agents or reduce media, then export again and check the new package.",
    "taskDone": "Processing ended: {{processed}} / {{total}}",
    "taskPartial": "Partially completed: {{count}} items failed. Check and retry.",
    "taskImportPartial": "Partially completed: {{count}} items failed. Check and preview only those objects again. Successful objects are not rolled back automatically.",
    "taskFailed": "Processing failed. Check the package or assets and retry.",
    "taskFailedShort": "Failed",
    "taskInterruptedShort": "Interrupted; check target",
    "taskInterrupted": "Import was interrupted and some content may already be saved. Check the object results below, then preview only the content that still needs changes; do not blindly repeat the replacement.",
    "taskResultCounts": "Confirmed successful: {{succeeded}} · Failed: {{failed}} · Unconfirmed: {{unresolved}}",
    "taskLastRecordedObject": "Last recorded workflow ID",
    "taskObjectId": "Workflow ID",
    "taskObjectSucceeded": "Confirmed successful",
    "taskObjectFailed": "Confirmed failed",
    "taskObjectUnconfirmed": "Needs verification",
    "taskUnconfirmedHelp": "A missing acknowledgement does not mean nothing was saved. Check each unconfirmed target and its status, then preview only the objects that still need changes. Successful objects are not rolled back automatically.",
    "taskSelectionUnavailable": "This older task has no complete object list. Check the remaining objects against the original package batch.",
    "taskReading": "Reading task status…",
    "taskReadFailed": "Progress is unavailable. The task may still be running. Retry the query.",
    "taskClose": "Closing this window does not cancel the task. Continue from transfer history.",
    "download": "Download package",
    "downloadFailed": "Download failed. Retry.",
    "taskStarted": "Background task started",
    "taskStartFailed": "Unable to start the task. Retry.",
    "noHistory": "No transfer history",
    "exportType": "Export",
    "importType": "Import",
    "failureItems": "Failed items",
    "transferState": "Processing status",
    "upload": "Upload image",
    "uploading": "Uploading",
    "uploadDone": "Image uploaded",
    "uploadFailed": "Image upload failed. Retry.",
    "uploadType": "Choose a JPG, PNG or WEBP image",
    "uploadSize": "Images must not exceed 10 MB",
    "removeCover": "Remove cover",
    "error_invalidId": "{{field}} must be a valid integer ID. Use a string to preserve its exact value.",
    "error_invalidIdList": "{{field}} must be a JSON array of integer IDs.",
    "error_invalidJson": "{{field}} is not valid JSON. Check its syntax.",
    "error_jsonObject": "{{field}} must be a JSON object.",
    "error_configArrays": "{{field}} requires inputs and outputs arrays.",
    "error_missingWorkflow": "The associated workflow is missing. Refresh and retry.",
    "error_invalidCover": "The original cover configuration cannot be read. Check its details and retry.",
    "error_invalidVisibility": "The original visibility configuration cannot be read. Check its details and retry.",
    "error_associationMode": "Choose a creation mode.",
    "error_invalidStatus": "Choose a valid publication status.",
    "listReadFailed": "The list could not be refreshed. Previous results are retained. Refresh before editing.",
    "targetEnvironment": "Import target",
    "CN_TEST": "China test environment",
    "INTL_TEST": "International test environment",
    "CN_PROD": "China production environment",
    "INTL_PROD": "International production environment",
    "unknownEnvironment": "Current environment is unknown",
    "previewPackage": "Check package and affected items",
    "previewFailed": "The package check could not be completed. Your file is still selected; try again.",
    "previewExpired": "This preview has expired or its validity cannot be verified. Run the preview again before confirming.",
    "previewIssues": "Resolve these issues before importing",
    "importAction": "Import action",
    "createNew": "Create",
    "updateExisting": "Update existing item",
    "transferType": "Type",
    "editNote": "Saving updates only changed fields and keeps the publication status.",
    "conflict": "This agent changed after you opened it. Your edits are retained. Reopen its details and compare before saving.",
    "coverEmpty": "No cover",
    "coverLoading": "Loading cover",
    "coverSourceInvalid": "The cover address is invalid. Check the cover configuration.",
    "coverUnavailable": "Failed",
    "coverReadFailed": "The cover could not be loaded. Retry loading it.",
    "retryCover": "Retry loading cover",
    "historyReadFailed": "Transfer history could not be refreshed. Displayed records may be out of date. Retry or open details to check.",
    "coverPreview": "Preview cover",
    "coverCn": "Chinese",
    "coverEn": "English",
    "coverSwitch": "Switch cover language",
    "configuration_invalid": "Configuration validation failed. Check this field.",
    "configuration_json": "{{path}}: invalid JSON syntax.",
    "configuration_object": "{{path}}: a JSON object is required.",
    "configuration_graph": "{{path}}: incomplete execution or editor graph.",
    "configuration_arrays": "{{path}}: inputs and outputs arrays are required.",
    "configuration_node": "{{path}}: a node name and parameter array are required.",
    "configuration_params": "{{path}}: parameters require identifiers and types.",
    "configuration_mapping": "{{path}}: incomplete composite parameter mapping.",
    "configuration_missingNode": "{{path}}: the referenced node is missing. Check both workflow files.",
    "configuration_missingInput": "{{path}}: the execution node has no matching input.",
    "configuration_virtualNode": "{{path}}: invalid batch quantity node or parameter.",
    "configuration_range": "{{path}}: invalid default value or numeric range.",
    "configuration_nodeId": "{{path}}: node IDs must be valid integers.",
    "configuration_duplicate": "{{path}}: duplicate node or parameter mapping.",
    "configuration_languageMapping": "{{path}}: Chinese and English configurations reference different nodes or inputs.",
    "replaceOnlineTitle": "Replace online agent content?",
    "replaceOnlineBody": "Target: {{environment}}. {{count}} agents are online. Importing keeps them online and immediately replaces their content. Confirm this package has been tested and the original package is retained."
  },
  "jsonEditor": {
    "importFailed": "Could not read the file. Select it again.",
    "expandBranch": "Expand {{path}}",
    "collapseBranch": "Collapse {{path}}",
    "empty": "No content",
    "expand": "Expand all",
    "collapse": "Collapse all",
    "importFile": "Import file",
    "importDone": "File imported",
    "invalid": "Invalid JSON. Check the content.",
    "copy": "Copy",
    "copied": "Copied to clipboard",
    "copyFailed": "Copy failed. Retry.",
    "download": "Download",
    "downloadDone": "File downloaded",
    "downloadFailed": "Download failed. Retry.",
    "format": "Format",
    "formatted": "Formatted",
    "editMode": "Edit mode",
    "viewMode": "View mode",
    "plainText": "Plain text",
    "valid": "Valid JSON",
    "characters": "Characters: {{count}}"
  }
};
